/* Reads ?combo=<handle> and checks that buy box radio. No param: do nothing. */
(function () {
  var handle = "";
  try {
    handle = new URLSearchParams(window.location.search).get("combo") || "";
  } catch (e) {
    return;
  }
  if (!/^[a-z0-9-]+$/.test(handle)) return;

  function apply() {
    var root = document.querySelector("[data-piolet-combo]");
    if (!root) return false;
    var input = root.querySelector('input[name="piolet_combo"][value="' + handle + '"]');
    if (!input) return false;
    if (input.checked) return true;
    var group = root.querySelectorAll('input[name="piolet_combo"]');
    for (var i = 0; i < group.length; i++) {
      if (group[i] === input) group[i].setAttribute("checked", "checked");
      else group[i].removeAttribute("checked");
      group[i].checked = group[i] === input;
    }
    input.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  function boot() {
    apply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
    document.addEventListener("DOMContentLoaded", boot);
  }
})();
